import React from 'react';

import { Button, Icon } from '@column/column-ui-kit';

import { PageActions } from '~/app/Layout/PageFrameContext';
import { ROUTE } from '~/app/routes';
import { ReportingTable } from '~/components/ReportingTable';
import { useNavigate } from '~/lib/navigation';

export const PageReporting: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageActions>
        <Button onClick={() => navigate(`${ROUTE.REPORTING}/schedule`)} size="small" icon={<Icon.Plus />}>
          Schedule Report
        </Button>
      </PageActions>
      <ReportingTable
        tableId="reporting"
        filter={{ category: 'settlement' }}
        empty={{
          icon: <Icon.AnimationDocument />,
          title: 'No reports found',
          description: 'Schedule your first report to get started.',
          action: (
            <Button onClick={() => navigate(`${ROUTE.REPORTING}/schedule`)} size="small" icon={<Icon.Plus />}>
              Create Report
            </Button>
          ),
        }}
        onRowClick={(entry) => navigate(`${ROUTE.REPORTING}/${entry.id}`)}
        visibleFiles={['csv', 'json']}
      />
    </>
  );
};
